<template>
    <modal id="daily-report-modal"
           size="large"
           v-model="showModal"
           :title="generateModalTitle('daily_report')"
           @submit="submitData" :loading="loading"
           :preloader="preloader">

        <form
            ref="form"
            :data-url='selectedUrl ? selectedUrl : `${TENANT_BASE_URL}app/daily-report/list`'
            @submit.prevent="submitData"
        >
            <div class="row">
                <div class="col-md-6">
                    <app-form-group-selectable
                        list-value-field="name"
                        type="select"
                        :label="$t('status')"
                        v-model="formData.status"
                        :chooseLabel="$t('status')"
                        :error-message="$errorMessage(errors, 'status')"
                        :fetch-url="`${TENANT_BASE_URL}api/daily-report/status`"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        type="date"
                        :label="$t('report_date')"
                        :placeholder="$placeholder('report_date')"
                        v-model="formData.report_date"
                        :error-message="$errorMessage(errors, 'report_date')"
                        :required="true"
                    />
                </div>
                <!-- <div class="col-md-12">
                    <app-form-group
                        :label="$t('attachments')"
                        type="file"
                        v-model="files"
                        :multiple="true"
                        :placeholder="$placeholder('attachments', '')"
                        :file-label="$placeholder('attachments', '')"
                        :error-message="$errorMessage(errors, 'attachments.0')"
                    />
                </div> -->
                <div class="col-md-12">
                    <app-form-group
                        type="textarea"
                        :label="$t('work_content')"
                        :placeholder="$textAreaPlaceHolder('work_content')"
                        v-model="formData.work_content"
                        :text-area-rows="3"
                        :error-message="$errorMessage(errors, 'work_content')">
                    </app-form-group>
                </div>
                <div class="col-md-12">
                    <app-form-group
                        type="textarea"
                        :label="$t('problems')"
                        :placeholder="$textAreaPlaceHolder('problems')"
                        v-model="formData.problems"
                        :text-area-rows="3"
                        :error-message="$errorMessage(errors, 'problems')">
                    </app-form-group>
                </div>
                <div class="col-md-12">
                    <app-form-group
                        type="textarea"
                        :label="$t('plans_for_tomorrow')"
                        :placeholder="$textAreaPlaceHolder('plans_for_tomorrow')"
                        v-model="formData.plans_for_tomorrow"
                        :text-area-rows="3"
                        :error-message="$errorMessage(errors, 'plans_for_tomorrow')">
                    </app-form-group>
                </div>

                <div class="col-md-12">
                    <div class="form-group">
                        <label>{{ $t('attachments') }}</label>
                        <app-input
                            type="dropzone"
                            v-model="files"
                            :error-message="$errorMessage(errors, 'files.0')"
                        />
                        <small class="text-muted font-italic mt-3 d-inline-block">
                            {{ $t('document_recommendation') }}
                        </small>
                    </div>
                </div>

                <div class="col-md-12" v-if="current_files.length">
                    <div class="form-group">
                        <label>{{ $t('current_files') }}</label>
                        <div class="img-container">
                            <div class="img-box" v-for="(url, index) in current_files" :key="'current-image-' + index">
                                <img v-if="isImage(url)"
                                    :src="url"
                                    class="img-thumbnail"
                                    :title="getFileName(url)"
                                />
                                <div v-else
                                    :href="url"
                                    target="_blank"
                                    class="d-flex align-items-center justify-content-center text-truncate img-thumbnail"
                                    :title="getFileName(url)"
                                >
                                    <i :class="`fa fa-file-${getFileExtension(url).substring(1)}`"></i>
                                </div>
                                <div class="img-action">
                                    <button type="button" class="btn btn-sm btn-primary" @click="viewFile(url)" :title="$t('view')">
                                        <i class="fas fa-eye"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </modal>
</template>

<script>
import FormHelperMixins from "../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../common/Mixin/Global/ModalMixin";
import {formDataAssigner} from "../../../../common/Helper/Support/FormHelper";
import {TENANT_BASE_URL} from "../../../../common/Config/UrlHelper";
import {formatDateForServer, today} from "../../../../common/Helper/Support/DateTimeHelper";

export default {
    name  : "DailyReportCreateModal",
    mixins: [FormHelperMixins, ModalMixin],
    data() {
        return {
            TENANT_BASE_URL,
            files   : [],
            current_files: [],
            deleted_files: [],
            formData: {
                report_date: formatDateForServer(today()),
            },
        }
    },
    methods: {
        submitData() {
            this.loading = true

            let url      = this.$refs.form.dataset['url'];
            let formData = formDataAssigner(new FormData, this.formData);

            formData.set('report_date', formatDateForServer(this.formData.report_date))

            this.files.forEach(file => formData.append('attachments[]', file))

            if (this.selectedUrl) {
                // for file update need to send by post.
                formData.append('_method', 'PATCH');
            }

            this.deleted_files.forEach(fileUrl => formData.append('deleted_files[]', fileUrl));
            this.loading = true;

            this.submitFromFixin('post', url, formData);
        },
        afterSuccess({data}) {
            this.formData = {};
            $('#daily-report-modal').modal('hide');
            this.$emit('input', false);
            this.toastAndReload(data.message, 'daily-report-table');
            this.$hub.$emit('reload-data-daily-report', data.daily_report);
        },
        afterSuccessFromGetEditData(response) {
            this.preloader = false;
            this.current_files = response.data.attachments ? response.data.attachments : [];
            this.formData  = response.data;
        },
    },
}
</script>

